
<div class="wrapper scrollable-container">
<channels-header *ngIf="loaded && !isEmbedChannel"  (onSearch)="onSearch($event)" (onCancelSearch)="onCancelSearch()" [searchBar]="true"  [opacity]="true" ></channels-header>

<div  *ngIf="channel; loader">
<div  [style.background]="channel.cover_image ? 'url('+channel.cover_image+')' : ''"  class="cover">


	<div  *ngIf="loaded && !isEmbedChannel"  class="container">
		<a class="backLink" [routerLink]="['/channel']">
		<div>
	<nb-icon pack="eva" icon="arrow-back-outline"></nb-icon><span>Всі канали</span>
		</div>
	</a>
	</div>

</div>


<div class="container">
	
		<div class="container-wrapper">

			<div class="description-wrapper">
				<div  class="description">
					<div class="image"><div  [style.background]="channel.avatar_image ? 'url('+channel.avatar_image+')' : ''"></div></div>
					<div class="text">
						<h5>{{channel.title}}</h5>
						<p>{{channel.description}}</p>
 
					</div>
		 
				</div>





				<div class="socialNetworks">
 			<a target="_blank" *ngIf="channel.site" href="{{channel.site}}" class="socNetItem">
					<div class="icon site"></div> <div class="text">WWW</div>
				</a>
				 <a target="_blank" *ngIf="channel.soc_facebook" href="{{channel.soc_facebook}}" class="socNetItem">
					<div class="icon facebook"></div> <div class="text">Facebook</div>
				</a>

				 <a target="_blank" *ngIf="channel.soc_twitter" href="{{channel.soc_twitter}}"  class="socNetItem">
					<div class="icon twitter"></div> <div class="text">Twitter</div>
				</a>

				 <a  target="_blank" *ngIf="channel.msg_whatsapp" href="{{channel.msg_whatsapp}}" class="socNetItem">
					<div class="icon whatsapp"></div> <div class="text">Whatsapp</div>
				</a>

				 <a   target="_blank" *ngIf="channel.msg_telegram" href="{{channel.msg_telegram}}" class="socNetItem">
					<div class="icon telegram"></div> <div class="text">Telegram</div>
				</a>

				
				 <a  target="_blank" *ngIf="channel.soc_instagram" href="{{channel.soc_instagram}}" class="socNetItem">
					<div class="icon instagram"></div> <div class="text">Instagram</div>
				</a>

				 <a  target="_blank" *ngIf="channel.msg_viber" href="{{channel.msg_viber}}" class="socNetItem">
					<div class="icon viber"></div> <div class="text">Viber</div>
				</a>

				 <a  target="_blank" *ngIf="channel.soc_vk" href="{{channel.soc_vk}}" class="socNetItem">
					<div class="icon vk"></div> <div class="text">Вконтакте</div>
				</a>

				</div>
 								
			</div>
 
			<div  class="content">
				 <div class="tabs">
					<div class="tab-item" (click)="currentTab =  tabs.streams;  setAncor('');" [class.active]="currentTab === tabs.streams">Трансляції</div>
					<a class="tab-item"  (click)="currentTab =  tabs.videos; setAncor('videos');" [class.active]="currentTab === tabs.videos">Відео</a>
					<!-- <div class="tab-item"  (click)="currentTab =  tabs.anonces; setAncor('anonces');"  [class.active]="currentTab === tabs.anonces">Анонсы</div> -->


					<div class="tab-item" (click)="currentTab =  tabs.playlists; setAncor('playlists');"  [class.active]="currentTab === tabs.playlists">Плейлисти</div>
				</div>



 			
				<div class="tabsContent" *ngIf="!loading; else loader">


 	<div  class="searchBlock" *ngIf="searchText"><h5>Пошук: "{{searchText}}"</h5></div>



				<div class="" *ngIf="currentTab === tabs.playlists">


					<div *ngIf="!currentPlaylist" class="playlists">
 				 	
						<div (click)="setSelectedPlaylist(playlist)" class="playlist-item" *ngFor="let playlist of channel.playlists" >
					<div class="playlist-cover"  [style.background]="playlist.coverImage ? 'url('+playlist.coverImage+')' : ''" ></div>

						 
							<div class="playlist-title">
								<div>{{playlist.title}}</div>
					 <div style="font-size:9px;">
						{{ playlist.videosCount ? 'Відео: ' : ''}} 							        <strong>{{ playlist.videosCount ?  playlist.videosCount : ''}}</strong>
						{{playlist.streamsCount ?  'Трансляцій: ' : ''}}
						<strong>{{playlist.streamsCount ?   playlist.streamsCount  : ''}}</strong>
					</div>
 
							</div>
						</div>

					</div>


				
				
					<div *ngIf="currentPlaylist" class="selected-playlist">

			<div class="playlist-info">
				<div class="link-wrap">
			<a href="javascript:;" (click)="currentPlaylist = null; setAncor('playlists') " >Усі плейлисти</a>
				</div>

				<div class="inf">

					<div *ngIf="currentPlaylist.coverImage" [style.background]="'url('+currentPlaylist.coverImage+')'" class="cover"></div>
					
					<div class="text">

						<div class="title">{{currentPlaylist.title}}</div>


						<div class="description">{{currentPlaylist.description}}</div>

						
						 <div style="font-size:9px;">
							{{ currentPlaylist.videosCount ? 'Відео: ' : ''}} 							        <strong>{{ currentPlaylist.videosCount ?  currentPlaylist.videosCount : ''}}</strong>
							{{currentPlaylist.streamsCount ?  'Трансляцій: ' : ''}}
							<strong>{{currentPlaylist.streamsCount ?   currentPlaylist.streamsCount  : ''}}</strong>
						</div>
 
				

					</div>

					<div *ngIf="currentPlaylist.saleMode && currentPlaylist.price && currentPlaylist.items.length" class="buylist">
						

						<div class="btn-wrapp"><button status="primary" size="small" 
						     (click)="buyNowPlaylist($event, currentPlaylist)" 
						     nbButton >КУПИТИ</button></div>

						<div class="price-wrapp"> <div class="price">{{currentPlaylist.price | additionPercentage}} грн.</div></div>
		


					</div>

				</div> 


			</div>




				<div  class="streams">    
						
			<!--[routerLink]="['/watch']"  [queryParams]="{v: item.publicIdentity}" -->
<div class="stream-item" (click)="openWatch(item)"  *ngFor="let item of currentPlaylist.items">
 
					<div *ngIf="item.saleMode && item.price" (click)="buyNowKey($event, item )" class="buyKey" ><span class="price">{{item.price | additionPercentage}}</span><span class="curency"> грн.</span><nb-icon class="icon" icon="shopping-cart-outline"></nb-icon> </div>


							<div class="stream-cover"  [style.background]="item.thumbImage ? 'url('+item.thumbImage+')' : ''" >
 

	 
	  <div class="live-label2" *ngIf="liveIds.includes(item._id)" >
					<div class="lbl live">LIVE</div>
					</div> 
	 


		 <div class="stat-label">
					<div class="lbl stat">  
				<span style="margin-right:3px;"><nb-icon  style="font-size:16px; color: #fff;" [icon]="'eye-outline'" pack="eva"></nb-icon></span> 									<span>{{item.stat?.visitors || 0}}</span>

					</div>
		</div>	

 <!---->
</div> 
							<div class="stream-title">{{item.title}}</div>
							
						</div>





                </div>




				       </div>
<div    *ngIf="currentPlaylist && !currentPlaylist?.items?.length"> 
						 <p *ngIf="searchText">Результатів не знайдено</p> 
						 <p style="margin-top:15px;" *ngIf="!searchText">Плейлист порожній</p> 
					</div>

				      

 
				<div    *ngIf="!currentPlaylist && !channel.playlists?.length"> 
						 <p *ngIf="searchText">Результатів не знайдено</p> 
						 <p style="margin-top:15px;" *ngIf="!searchText">Плейлистів поки немає</p> 
					</div>


				</div>



					<div  class="streams" *ngIf="currentTab === tabs.streams">

						
<!--[routerLink]="['/watch']"  [queryParams]="{v: stream.publicIdentity}"-->
<div class="stream-item"  (click)="openWatch(stream)" *ngFor="let stream of channel.streams">

					<div *ngIf="stream.saleMode && stream.price && stream.accessLevel === 1" (click)="buyNowKey($event, stream  )" class="buyKey" ><span class="price">{{stream.price}}</span><span class="curency"> грн.</span><nb-icon class="icon" icon="shopping-cart-outline"></nb-icon> </div>
							<div class="stream-cover"  [style.background]="stream.coverImage ? 'url('+stream.thumbImage+')' : ''" >

		  <div class="live-label2" *ngIf="stream.isRunning">
					<div class="lbl live">LIVE</div>
					</div> 

		 <div class="stat-label">
					<div class="lbl stat">  
				<span style="margin-right:3px;"><nb-icon  style="font-size:16px; color: #fff;" [icon]="'eye-outline'" pack="eva"></nb-icon></span> 									<span>{{stream.stat?.visitors || 0  }}</span>

					</div>
		</div>	

 <!---->
</div> 
							<div class="stream-title">{{stream.title}}</div>
							
						</div>


						<div    *ngIf="!channel.streams?.length"> 
						 <p *ngIf="searchText">Результатів не знайдено</p> 
						 <p style="margin-top:15px;" *ngIf="!searchText">Трансляцій немає або приховані автором каналу</p> 
					</div>



					</div>
					<div class="streams" *ngIf="currentTab === tabs.videos">
	<!-- <div  class="searchBlock" *ngIf="searchText"><h5>Поиск: "{{searchText}}"</h5></div>-->


				<!--  [routerLink]="['/watch']"  [queryParams]="{v: video.publicIdentity}"  -->
<div class="stream-item"  (click)="openWatch(video)"  *ngFor="let video of channel.videos">
 
					<div *ngIf="video.saleMode && video.price && video.accessLevel === 1" (click)="buyNowKey($event, video )" class="buyKey" ><span class="price">{{video.price}}</span><span class="curency"> грн.</span><nb-icon class="icon" icon="shopping-cart-outline"></nb-icon> </div>


							<div class="stream-cover"  [style.background]="video.coverImage ? 'url('+video.thumbImage+')' : ''" >
 

		 <div class="stat-label">
					<div class="lbl stat">  
				<span style="margin-right:3px;"><nb-icon  style="font-size:16px; color: #fff;" [icon]="'eye-outline'" pack="eva"></nb-icon></span> 									<span>{{video.stat?.visitors || 0}}</span>

					</div>
		</div>	

 <!---->
</div> 
							<div class="stream-title">{{video.title}}</div>
							
						</div>








						
						<div   *ngIf="!channel.videos?.length"> 
							 <p *ngIf="searchText">Результатів не знайдено</p> 
							 <p style="margin-top:15px;" *ngIf="!searchText">Відео немає або приховані автором каналу</p> 
						</div>

					</div>
					<div *ngIf="currentTab === tabs.anonces">
	<!--<div class="searchBlock" *ngIf="searchText"><h5>Поиск: "{{searchText}}"</h5></div> 

						<div   *ngIf="!channel.announcements?.length"> 
							 <p *ngIf="searchText">Результатів не знайдено</p> 
							 <p style="margin-top:15px;" *ngIf="!searchText">Анонсов пока нет</p> 

						</div>

<!--
						<div *ngIf="channel.announcements?.length" class="announcements">

							<div *ngFor="let annonce of channel.announcements" class="announcementsItem">
							<div class="announcementsItemImage"  [style.background]="annonce.thumbImage ? 'url('+annonce.thumbImage+')' : ''" ></div>
								<div class="announcementsItemContent">
									<h5>{{annonce.title}}</h5>
									<p>{{annonce.description}}</p>
									<div class="bottom">
									 <div class="date">
									{{annonce.show_date}}

									</div>
									 <div *ngIf="annonce.saleMode" class="sale">{{annonce.price}}</div>



									</div>

								</div>
								


							</div>

						</div>


					</div> -->


				</div>		

</div>

			</div>

		</div>
 

 
	 


 </div>




</div>


		  
		   <ng-template #loader>
        <div class="row">
		<div class="col">
		<div style="display:flex;  width:100%; height:300px; "> 
			<div style="display:flex;margin: auto;"> <app-loader></app-loader></div>
		    
		 </div>
		 </div>
        </div>
    </ng-template> 

